export const OVERALL_LABEL: Record<string, string> = {
  mostly_positive: "Mostly Positive",
  mixed: "Mixed",
  challenging: "Challenging",
};

export const OVERALL_COLOR: Record<string, string> = {
  mostly_positive: "var(--ish-success, #16a34a)",
  mixed: "var(--ish-warning, #ca8a04)",
  challenging: "var(--ish-error, #dc2626)",
};
